import React, { useEffect, useRef } from 'react';

const ContextMenu = ({ x, y, items, onClose }) => {
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    // Adjust position if close to screen edge
    const style = {
        top: y,
        left: x,
    };
    
    // Simple adjustment (can be improved with measuring)
    if (x + 200 > window.innerWidth) {
        style.left = x - 200;
    }
    if (y + 200 > window.innerHeight) {
        style.top = y - 200; // Crude but prevents cutoff at bottom
    }

    return (
        <div 
            ref={menuRef}
            className="fixed z-[9999] bg-white border border-gray-200 shadow-lg rounded py-1 min-w-[150px] text-sm text-gray-700"
            style={style}
        >
            {items.map((item, index) => (
                <div 
                    key={index}
                    className="px-4 py-2 hover:bg-blue-50 hover:text-blue-600 cursor-pointer transition-colors flex items-center gap-2"
                    onClick={(e) => {
                        e.stopPropagation();
                        item.onClick();
                        onClose();
                    }}
                >
                    {item.label}
                </div>
            ))}
        </div>
    );
};

export default ContextMenu;
